import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore } from "redux-persist";
import rootReducer from "./root-reducer";

// @ts-expect-error fix later
const store = createStore(rootReducer, composeWithDevTools());

const persistor = persistStore(store);

export { persistor, store };
